<template>
  <b-card>
    <b-tabs>
      <b-tab>
        <template #title>
          <span>Delete Reasons</span>
        </template>

        <delete-reasons />
      </b-tab>
      <b-tab>
        <template #title>
          <span>Leave Reasons</span>
        </template>

        <leave-reasons />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import { BCard, BTabs, BTab } from 'bootstrap-vue'
import DeleteReasons from './DeleteReasons.vue'
import LeaveReasons from './LeaveReasons.vue'

export default {
  components: {
    BCard, BTabs, BTab, DeleteReasons, LeaveReasons,
  },
}
</script>
